import { useMemo } from 'react';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { useEmployeeEnrollmentsStore } from '../../stores/useEmployeeEnrollments.store';

export const useGetDefaultCoverageTierDataFromBackend = (planId?: string, contributionMonitoringRequired?: boolean) => {
  const enrollments = useEmployeeEnrollmentsStore((state) => state.enrollments);
  const [coverageTierType, coverageTierEffectiveDate] = useMemo(() => {
    const enrollment = enrollments?.find((item) => item?.planId === planId);
    return [
      enrollment?.coverageTierType,
      dayjs(enrollment?.coverageTierEffectiveDate).format(DEFAULT_DATE_FORMAT),
    ];
  }, [enrollments, planId]);
  const defaultCoverageTierDataFromBackend = useMemo(() => {
    if (contributionMonitoringRequired) return {};

    return {
      coverage_level: coverageTierType,
      coverage_level_effective_date: coverageTierEffectiveDate,
    };
  }, [contributionMonitoringRequired, coverageTierType, coverageTierEffectiveDate]);

  return { defaultCoverageTierDataFromBackend };
};
